import React from "react";
import styles from "./CatalogManagement.module.scss";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import Item from "../../../../shared/item/Item";
import { Table, TableHead, withStyles } from "@material-ui/core";
import {
  CheckBoxTableCell,
  NonEditTableCell,
  SpecsTableCell,
  WarningTableCell,
} from "../../../../shared/pricing/dealerFees/TableComponents";

export const SpecsTableCellCatalogId = withStyles({
  root: {
    width: "15%",
    textAlign: "right",
  },
})(SpecsTableCell);
const CatalogRow = (props) => {
  return (
    <div
      className={`${styles.rowBorderHighlight} ${
        props.catalogData.paActive
          ? styles.paActiveStyle
          : (props.catalogData.infoActive && styles.infoActiveStyle) || ""
      }`}
    >
      <Table>
        <TableHead>
          <tr>
            <WarningTableCell />
            <CheckBoxTableCell>
              <CheckBox
                id={"toggleCheckbox" + props.index}
                checked={props.catalogData.active}
                isDisabled={true}
              />
            </CheckBoxTableCell>
            <NonEditTableCell
              className={`${styles.rowItemBold} ${styles.center}`}
            >
              <Item
                datatestid={"market" + props.index}
                value={props.catalogData.market}
              />
            </NonEditTableCell>
            <NonEditTableCell
              className={`${styles.rowItemBold} ${styles.center}`}
            >
              <Item
                datatestid={"model" + props.index}
                value={props.catalogData.model}
              />
            </NonEditTableCell>
            <NonEditTableCell
              className={`${styles.rowItemBold} ${styles.center}`}
            >
              <Item
                datatestid={"year" + props.index}
                value={props.catalogData.year}
              />
            </NonEditTableCell>

            <SpecsTableCellCatalogId>
              <Item value={props.catalogData.catalogId} />
            </SpecsTableCellCatalogId>
            <NonEditTableCell>
              <span
                className={styles.pendingAction}
                onClick={() => props.onEditClick(props.catalogData)}
                id={"action" + props.index}
              />
              <span
                className={styles.informationAction}
                onClick={() => props.onInfoClick(props.catalogData)}
                id={"information" + props.index}
              />
            </NonEditTableCell>
          </tr>
        </TableHead>
      </Table>
    </div>
  );
};
export default CatalogRow;
